<div class="container">
  <header class="row">
    <div class="col-12">
      <app-title-with-back>Envío de notificaciones masivas</app-title-with-back>
    </div>
  </header>
  <div class="notifications-form-container">
    <form [formGroup]="form" class="row" (ngSubmit)="onSubmit()">
      <div class="col-12">
        <uni-form-field>
          <uni-label>Mensaje:</uni-label>
          <textarea uniInput id="mensaje" formControlName="mensaje" rows="6"></textarea>
        </uni-form-field>
      </div>
      <div class="col-md-6">
        <uni-form-field>
          <uni-label>CTA:</uni-label>
          <input uniInput formControlName="cta" />
        </uni-form-field>
      </div>
      <div class="col-md-6">
        <uni-form-field>
          <uni-label>Link:</uni-label>
          <input uniInput formControlName="link" />
        </uni-form-field>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="date">Fecha:</label>
          <input
            [disabled]="massiveNotification"
            id="date"
            type="datetime-local"
            class="form-control"
            formControlName="date"
            [min]="minDate"
            [max]="maxDate"
            [disabled]="true"
          />
        </div>
      </div>

      <div class="col-md-6 p-0">
        <div class="col-md-12">
          <div class="form-check column-check">
            <input
              name="all-checkbox"
              type="checkbox"
              class="form-check-input"
              formControlName="checkbox"
              [(ngModel)]="massiveNotification"
              (click)="toggleTestNotification()"
            />
            <label for="all-checkbox">Enviar notificación masiva</label>
          </div>
        </div>
        <div class="col-md-12" *ngIf="!massiveNotification">
          <uni-form-field>
            <input type="email" placeholder="Escriba el correo aquí" uniInput formControlName="email" />
          </uni-form-field>
        </div>
      </div>

      <div class="col-md-12 pt-3 d-sm-flex justify-content-sm-between">
        <button type="button" uni-button variant="secondary" (click)="onCancel()">Cancelar</button>
        <button type="submit" uni-button [disabled]="form.invalid">Enviar</button>
      </div>
    </form>
  </div>
</div>
